import script from "./PersonalfragenMenue.vue?vue&type=script&setup=true&lang=js"
export * from "./PersonalfragenMenue.vue?vue&type=script&setup=true&lang=js"

import "./PersonalfragenMenue.vue?vue&type=style&index=0&id=8d4e754e&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8d4e754e"]])

export default __exports__